import BIBenefits from 'components/RwdBasket/RwdBasketLayout/BIBenefits/BIBenefits';

export default BIBenefits;
